import { Layout, Page, ContextualSaveBar } from "@shopify/polaris";
import { useRef, useEffect } from "react";
import { useHistory } from "react-router";
import { useMutation } from "react-query";
import { useSnackbar } from "providers";

import { createOneHorse } from "api";
import { SharedForm } from "../SharedForm/SharedForm";

export function NewHorse(props) {
  const skipToContentRef = useRef(null);

  const initialValues = useRef({
    name: "",
    avatar: undefined,
    status: "Aktif",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { toggleSnack } = useSnackbar();

  const postMutation = useMutation(createOneHorse, {
    onSuccess: (response) => {
      toggleSnack({
        key: "horseCreateSuccess",
        message: "At kaydı başarıyla oluşturulmuştur",
        active: true,
      });
    },
    onError: (error) => {
      toggleSnack({
        key: "horseCreateError",
        error: true,
        message: error?.response?.data?.message,
        active: true,
      });
    },
  });

  return (
    <Page
      title="Yeni At"
      narrowWidth={true}
      breadcrumbs={[{ content: "Atlar", url: "/horses" }]}
    >
      <Layout>
        <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
        <SharedForm
          onSubmit={(values) => postMutation.mutate(values)}
          initialValues={initialValues.current}
          savebarRender={(values) => (
            <Savebar {...values} isLoading={postMutation.isLoading} />
          )}
        />
      </Layout>
    </Page>
  );
}

function Savebar({ handleSubmit, isValid, isLoading }) {
  const history = useHistory();
  return (
    <ContextualSaveBar
      saveAction={{
        onAction: handleSubmit,
        loading: isLoading,
        disabled: !isValid,
        content: "Kaydet",
      }}
      message="Yeni At"
      discardAction={{
        onAction: () => history.push("/horses"),
        content: "Geri",
      }}
    />
  );
}
